import { Input, Output, EventEmitter, Directive, TemplateRef, ContentChild, ViewContainerRef } from '@angular/core';
import { GridHeaderTitleTemplateDirective } from './header-title-template.directive';

@Directive({ selector: 'grid-header-title' })
export class GridHeaderTitleDirective {
  // @Input()
  @ContentChild(GridHeaderTitleTemplateDirective, { read: TemplateRef }) template: TemplateRef<any>;
}
